import { useEffect, useState } from "react";

export const Livehorsetv = ({ id }) => {
    const [_width, setwidth] = useState()
    useEffect(() => {
        setTimeout(() => {
            const doc = document.getElementById('iframe-video')
            if (doc) {

                doc.contentWindow?.postMessage({ height: "400px", width: `${doc.width}` }, '*')
            }
        }, 1000)



        const handleMessage = (event) => {

            if (event.origin !== 'https://live.9xxbet.com') return;

            setwidth(event.data.width)
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <iframe style={{ aspectRatio: "16/10", maxWidth: '500px', width: `100%`, maxHeight: "300px" }} src={"https://live.9xxbet.com?eventId=" + id} frameBorder={0} id="iframe-video" className="overflow-hidden  mt-1 bg-transparent"></iframe>
        </div>

    )
}
